// src/admin/pages/TagsPage.jsx

import { useState } from "react";

import PageHeader from "../components/PageHeader";
import SearchInput from "../components/SearchInput";
import AdminModal from "../components/AdminModal";
import TagForm from "../components/TagForm";
import TagsTable from "../components/TagsTable";

import useTags from "../hooks/useTags";

export default function TagsPage() {

    const [open, setOpen] = useState(false);
    const [selectedTag, setSelectedTag] = useState(null);
    const [search, setSearch] = useState("");

    const {
        tags,
        loading,
        saving,
        deletingId,
        createTag,
        updateTag,
        deleteTag,
    } = useTags(search);

    const handleAdd = () => {
        setSelectedTag(null);
        setOpen(true);
    };

    const handleEdit = (tag) => {
        setSelectedTag(tag);
        setOpen(true);
    };

    const handleSubmit = async (data) => {

        if (selectedTag) {
            await updateTag(selectedTag.id, data);
        } else {
            await createTag(data);
        }

        setOpen(false);
        setSelectedTag(null);
    };

    return (
        <div className="space-y-8">

            <PageHeader
                title="Tags"
                subtitle="Content Management"
                actionButton={
                    <button
                        onClick={handleAdd}
                        className="
                            px-6
                            py-3
                            rounded-xl
                            bg-blue-800
                            text-white
                            font-semibold
                            hover:bg-blue-600
                            transition
                        "
                    >
                        Add Tag
                    </button>
                }
            />

            <SearchInput
                value={search}
                onChange={(value) => setSearch(value)}
                placeholder="Search tags..."
            />

            {loading ? (
                <div className="text-center py-16">
                    Loading tags...
                </div>
            ) : (
                <TagsTable
                    tags={tags}
                    deletingId={deletingId}
                    onDelete={deleteTag}
                    onEdit={handleEdit}
                />
            )}

            <AdminModal
                isOpen={open}
                title={selectedTag ? "Edit Tag" : "Add Tag"}
                onClose={() => {
                    setOpen(false);
                    setSelectedTag(null);
                }}
            >
                <TagForm
                    initialValues={selectedTag}
                    saving={saving}
                    onSubmit={handleSubmit}
                />
            </AdminModal>

        </div>
    );
}